export const OAUTHSTATE_LOCALSTORAGE_KEY = 'oauth-state';
export const SESSION_STORAGE_STATE_KEY = 'splitc-login-state';
export const SESSION_STORAGE_NONCE_KEY = 'splitc-login-nonce';
export const PROVIDER_TYPE_LOCAL_STORAGE_KEY = 'provider-type';
export const REDIRECT_TO_LOCAL_STORAGE_KEY = 'provider-type';
export const ID_TOKEN_COOKIE_NAME = 'sc_id_token';
